import ALL_EMPLOYEES_VALUE from "~/constants/employee/ALL_EMPLOYEES_VALUE";
import type BookingState from "~/routes/companies.$slug.bookings.new/bookingReducer/BookingState";

export default function serializeSearchParam(
  state: Pick<BookingState, "lineItems"> & {
    company: { id: string };
  } & {
    employeeId: string;
  },
  timeSlotPeriod: { startsAt: Date; endsAt: Date },
) {
  return btoa(
    JSON.stringify({
      lineItems: state.lineItems,
      companyId: state.company.id,
      startsAt: timeSlotPeriod.startsAt,
      endsAt: timeSlotPeriod.endsAt,
      employeeId:
        state.employeeId === ALL_EMPLOYEES_VALUE ? undefined : state.employeeId,
    }),
  );
}
